import React from 'react';
import { makeStyles,  createStyles } from '@material-ui/core';
import { getDataVersion } from '../../../services/ekispert/api';

const useStyles = makeStyles(() =>
  createStyles({
    subtitle: {
      textDecoration: 'underline'
    },
    annotation: {
      fontSize: '12px',
    }
  }),
);

const PublicServiceAboutBody: React.FC = () => {
  const [copyRights, setCopyRights] = React.useState<string[]> ([]);
  const [ init, setInit ] = React.useState(true);
  React.useEffect(()=>{
    if(init) {
      getCopyRights();
      setInit(false);
    }
  }, [init]);
  const getCopyRights = async () => {
    const dataVersion = await getDataVersion();
    const copyRights = dataVersion.Copyrights.text.split('\n');
    // 先頭の交承だけANAのものに差し替え
    copyRights[0] = "交承 令和2年 177号";
    setCopyRights(copyRights);
  }
  const classes = useStyles();
  return (
    <div>
      <h3 className={classes.subtitle}>このサービスについて</h3>
      <p>
        ご希望のスケジュールや条件に合わせた最適なANA便と地上交通機関の組み合わせ経路をご案内いたします。<br/>
        旅のプランニングから航空券予約までをワンストップで提供する「空港アクセスナビ」の新しいサービスです。
      </p>
      <h3 className={classes.subtitle}>推奨環境</h3>
      <p>●PC・スマートフォン（ブラウザ）</p>
      <p>Google chrome（最新版）</p>
      <p>Safari(最新版)</p>
      <p>●スマートフォン（OS）</p>
      <p>iOS11以降</p>
      <p>Android5.0以降</p>

      <h3 className={classes.subtitle}>時刻表について</h3>
      {
        copyRights && copyRights.map((x, index)=>{
          if(x){
            return (
              <p key={index}>{x}</p>
            )
          }
          return null;
        })
      }

      <p>※経路情報提供元：駅すぱあと</p>
      <p>「駅すぱあと」は株式会社ヴァル研究所の登録商標です。</p>
      <p>※鉄道運行情報：列車遅延など、鉄道の運行情報もご確認いただけます。</p>
      <p>鉄道運行情報提供元：株式会社レスキューナウ</p>


    </div>
  );
}

export default PublicServiceAboutBody;
